import { render } from "./NoticesView.vue?vue&type=template&id=c6038d58"
import script from "./NoticesView.vue?vue&type=script&lang=js"
export * from "./NoticesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__